import Cookies from "js-cookie";

const TokenKey = "Book-Token";
const SharedCookieDomain = "coursegate.cn";

function isCoursegateDomain() {
  const hostname = window.location.hostname;
  return hostname === SharedCookieDomain || hostname.endsWith(`.${SharedCookieDomain}`);
}

function getTokenCookieOptions() {
  const options = { path: "/" };

  if (isCoursegateDomain()) {
    options.domain = SharedCookieDomain;
  }

  return options;
}

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  const options = getTokenCookieOptions();

  // 清理旧的主机级 Cookie，避免它与根域 Cookie 同名时读取结果不确定。
  if (options.domain) {
    Cookies.remove(TokenKey, { path: "/" });
  }

  return Cookies.set(TokenKey, token, options);
}

export function removeToken() {
  Cookies.remove(TokenKey, { path: "/" });

  if (isCoursegateDomain()) {
    return Cookies.remove(TokenKey, {
      path: "/",
      domain: SharedCookieDomain
    });
  }
}
